import { render, staticRenderFns } from "./CreateMerchantStep2.vue?vue&type=template&id=315c2c22&"
import script from "./CreateMerchantStep2.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports